<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user' }">
          <div class="div2">用户信息</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <el-menu :default-active="currentIndex" class="el-menu-demo" mode="horizontal" @select="clickbtn">
        <el-menu-item v-for="(item, index) in btns" :index="index.toString()" :key="index">{{ item }}</el-menu-item>
      </el-menu>
      <!-- <h2>用户详情</h2> -->
    </div>
    <div class="content">
      <h2>用户详情</h2>
      <!-- <el-button
        v-for="(item, index) in btns"
        :key="index"
        :type="currentIndex == index ? 'primary' : ''"
        @click="clickbtn(index)"
      >
        {{ item }}
      </el-button> -->
      <userInfo v-if="currentIndex == 0" :id="userId"></userInfo>
      <orderInfo v-if="currentIndex == 1" :id="userId"></orderInfo>
      <addressInfo v-if="currentIndex == 2" :id="userId"></addressInfo>
      <!-- <bankCard v-if="currentIndex == 3"></bankCard> -->
      <commissionRecord v-if="currentIndex == 3" :id="userId"></commissionRecord>
      <!-- <collectRecord v-if="currentIndex == 5"></collectRecord> -->
      <fansRecord v-if="currentIndex == 4" :id="userId"></fansRecord>
      <cashRecord v-if="currentIndex == 5" :id="userId"></cashRecord>
      <couponRecord v-if="currentIndex == 6" :id="userId"></couponRecord>
    </div>
  </div>
</template>

<script>
import userInfo from '../components/userInfo.vue'
import orderInfo from '../components/orderInfo.vue'
import addressInfo from '../components/addressInfo.vue'
import bankCard from '../components/bankCard.vue'
import commissionRecord from '../components/commissionRecord.vue'
import collectRecord from '../components/collectRecord.vue'
import fansRecord from '../components/fansRecord.vue'
import cashRecord from '../components/cashRecord.vue'
import couponRecord from '../components/couponRecord.vue'
export default {
  components: {
    userInfo,
    orderInfo,
    addressInfo,
    bankCard,
    cashRecord,
    commissionRecord,
    collectRecord,
    fansRecord,
    couponRecord
  },
  data() {
    return {
      userId: '',
      currentIndex: '0',
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '地址信息', '佣金记录', '粉丝记录', '提现记录', '优惠券记录']
    }
  },
  created() {
    this.userId = this.$route.query.id
  },
  methods: {
    clickbtn(index) {
      this.currentIndex = index
    }
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
